import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
  gap: 24px;
  background-color: #fff;

  @media (max-width: 768px) {
    padding: 16px;
    gap: 16px;
  }
`;

export const ContentHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Title = styled.h1`
  font-family: 'Montserrat', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #0a1e3d;
  margin: 0;
`;

export const ActionToolbar = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;

  button {
    font-size: 14px;
    padding: 8px 16px;
    white-space: nowrap;
  }

  @media (max-width: 768px) {
    button {
      padding: 6px 12px;
      font-size: 12px;
    }
  }
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionTitle = styled.h2`
  font-family: 'Montserrat', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #0a1e3d;
  margin: 0;
  padding: 0;
`;

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const DishesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DishCard = styled.div`
  display: flex;
  gap: 16px;
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  align-items: flex-start;
  border-left: 4px solid #0a1e3d;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f0f3f7;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const DishImage = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 6px;
  object-fit: cover;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100px;
    height: 100px;
  }
`;

export const DishContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-grow: 1;
`;

export const DishName = styled.h3`
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #0a1e3d;
  margin: 0;
`;

export const DishDescription = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  color: #45464E;
  margin: 0;
  line-height: 1.4;
`;

export const DishMeta = styled.div`
  display: flex;
  gap: 16px;
  font-size: 12px;
  color: #666;
  font-family: 'Montserrat', sans-serif;
`;

export const DishPrice = styled.span`
  font-weight: 600;
  color: #0a1e3d;
`;

export const DishActions = styled.div`
  display: flex;
  gap: 8px;
  flex-shrink: 0;

  button {
    font-size: 12px;
    padding: 6px 12px;
  }
`;

export const ContentBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const AddDishContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  gap: 24px;
  background-color: white;
  width: 100%;
  flex: none;
  order: 0;
  flex-grow: 0;

  @media (max-width: 768px) {
    padding: 16px;
    gap: 16px;
  }
`;

export const AddDishContentHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  flex: none;
  order: 0;
`;

export const AddDishTitle = styled.h2`
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #0a1e3d;
  margin: 0;
  border-bottom: 2px solid #f0f0f0;
  padding-bottom: 12px;
  flex: none;
  order: 0;
  flex-grow: 0;
`;

export const AddDishContentBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  gap: 16px;
  width: 100%;
  max-width: 600px;
  flex: none;
  order: 1;
  flex-grow: 0;

  @media (max-width: 768px) {
    max-width: 100%;
    gap: 12px;
  }
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 0;
  margin-top: 16px;
  border-top: 1px solid #e0e0e0;

  @media (max-width: 768px) {
    padding: 16px 0;
    margin-top: 12px;
  }
`;
